module.exports = __webpack_public_path__ + "img/img-kingmaker.7ec284aa.png";